<div class="location">
  <input type="hidden" class="locationCountryCode" value="{{location.countryCode}}">
  <div class="d-flex p-2 justify-content-between">
    <div class="location-info">
      <span class="location-name">
        @if (location.slicName) {
<a (click)="onViewOnMapClick(location.countryCode, location.slicNumber)">
          <span class="on-property" title="{{localize(langSection.LocationList, langText.OpenOnPropertyView)}}" ></span>
        </a>
}
        <span class="fw-bold">{{location.slicName || localize(langSection.LocationList, langText.AllLocations)}}</span>
        @if (location.profile.forceReadOnly && location.profile.documentStatus != documentStatus.SoftDelete) {
<span class="view-only">{{ '(' + localize(langSection.Role, langText.ViewOnly) + ')' }}</span>
}
        @if (location.profile.documentStatus == documentStatus.SoftDelete) {
<span class="pending-removal">{{ '(' + localize(langSection.LocationList, langText.PendingRemoval) + ')' }}</span>
}
      </span>
      @if (!showCustomNameLink) {
<span title="{{location.profile.customName}}" (mouseenter)="showFullName()" (mouseleave)="hideFullName()" [ngClass]="{'ellipses-overflow': !showFullCustomName}">{{customerLocationName}}</span>
}
      @if (showCustomNameLink) {
<a href="#" (click)="openCustomNameModal($event); $event.preventDefault()">{{localize(langSection.LocationList, langText.CustomNameHyperlink)}}</a>
}
      <span class="ellipses-overflow" title="{{location.profile.address}}">{{location.profile.address | replace: emptyAddressRegex}}</span>
    </div>
    <div class="location-metrics">
      <div class="metrics-counts">
        <span>{{location.metrics.pendingCount}}</span>
        <span>{{location.metrics.inProgressCount}}</span>
        <span>{{location.metrics.completedCount}}</span>
      </div>
      <div class="metrics-labels">
        <span>{{localize(langSection.LocationList, langText.Pending)}}</span>
        <span>{{localize(langSection.LocationList, langText.InProgress)}}</span>
        <span>{{localize(langSection.LocationList, langText.Completed)}}</span>
      </div>
    </div>
    @if (location.metrics.unreadCommentsCount > 0) {
<span class="comments-indicator icon"></span>
}
  </div>
</div>
